import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { setConsentDefaults, initGA4 } from './lib/analytics'
import { initCapacitor } from './lib/capacitor'
import { initRuntimeApiConfig } from './lib/apiConfig'

// Consent Mode v2: set default-denied BEFORE any GA4 tags load
setConsentDefaults()

// Only init GA4 if user has already granted analytics consent
try {
  const raw = localStorage.getItem('dizee-cookie-consent')
  if (raw) {
    const consent = JSON.parse(raw)
    if (consent?.analytics) initGA4()
  }
} catch {
  // no stored consent — GA4 stays deferred until CookieBanner grants it
}

async function start() {
  await initRuntimeApiConfig()
  const { default: App } = await import('./App')
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
  initCapacitor()
}

void start()
